















import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import EditorSection from '@/editor/editor-block-view/components/EditorSection.vue';
import { IEditorContent, ISection, IMergeValues } from '@/editor/types';
import { EditorHelper } from '@/editor/helpers/editor.helper';
import { EBlockWidth } from '@/editor/types/enums';

@Component({
  components: {
    EditorSection,
  },
})
export default class EditorBlockView extends Vue {
  @Prop() content: IEditorContent;
  @Prop() mergeValues: IMergeValues;
  @Prop({ default: false }) isPdfViewer: boolean;
  @Prop() pageWidth: number;

  @Watch('pageWidth', { immediate: true }) watchPageWidth() {
    Vue.nextTick(() => {
      this.setBlockWidth(this.pageWidth || this.editorContainer?.offsetWidth);
    });
  }

  @Ref('editorContainer') editorContainer: HTMLElement;

  blockWidthClass: EBlockWidth = null;

  get sections(): ISection[] {
    return this.content?.sections;
  }

  setBlockWidth(width: number) {
    const blockWidth = EditorHelper.getBlockWidth(width);
    this.blockWidthClass = EditorHelper.getBlockWidthClass(blockWidth);
  }

  mounted() {
    Vue.nextTick(() => {
      this.$emit('loaded');
    });
  }
}
